import { render, staticRenderFns } from "./liveNotification.vue?vue&type=template&id=48b5c79a&scoped=true&"
import script from "./liveNotification.vue?vue&type=script&lang=js&"
export * from "./liveNotification.vue?vue&type=script&lang=js&"
import style0 from "./liveNotification.vue?vue&type=style&index=0&id=48b5c79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5c79a",
  null
  
)

export default component.exports